/**
 * Formats an Icelandic kennitala by:
 * 1. Adding a dash after the first 6 digits
 *
 * @param {string} kennitala - The kennitala to format
 * @returns {string} - The formatted kennitala
 *
 * @example
 * formatKennitala("1234567890") // returns "123456-7890"
 * formatKennitala("123456-7890") // returns "123456-7890"
 * formatKennitala("12345") // returns "12345" (unchanged if not 10 digits)
 */
export const formatKennitala = (kennitala) => {
    if (!kennitala) return "";

    // Remove any existing dashes
    let formattedKennitala = kennitala.replace(/-/g, "");

    // Add dash after first 6 digits if kennitala is 10 digits long
    if (formattedKennitala.length === 10) {
        formattedKennitala = `${formattedKennitala.slice(0, 6)}-${formattedKennitala.slice(6)}`;
    }

    return formattedKennitala;
};
